import { useState } from "react";
import { getParamsForAssignmentArchiveFile } from "service/api";

export const useDownloadAssignmentArchive = () => {
  const [isPending, setPending] = useState(false);

  const download = async (assignmentId: string) => {
    try {
      setPending(true);
      const res = await getParamsForAssignmentArchiveFile({
        assignmentId: assignmentId,
      });
      if (!res) throw new Error("No response");
      const { url: href, filename } = res;
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error: any) {
      console.error(error);
      alert(error.message)
    } finally {
      setPending(false);
    }
  };
  return { isPending, download };
};
